export default "__VITE_ASSET__DOTc6H8Y__"